
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NJDocData, NJDocDefTemplate, DOData, componentVM, NJReadDocDefTemplateLookup, DocdefDataVM } from '../DOData';
import { IServerSideGetRowsParams, IViewportDatasourceParams, RowNode } from 'ag-grid-community';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { fas, faCog, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CheckboxRendererComponent } from '../rendering/checkbox-cell-rending/checkbox-cell-rending.component';
import { ButtonRendererComponent } from '../rendering/button-cell-rendering/button-cell-rending.component';
import { DropdownRendererComponent } from '../rendering/dropdown-cell-rendering/dropdown-cell-rending.component';
import { i18n } from '@angular/core/src/render3';

@Component({
    selector: 'cylib-grid-internal-no-cache',
    templateUrl: './grid-internal-no-cache.component.html',
    styleUrls: ['./grid-internal-no-cache.component.css']
})
export class GridInternalNoCacheComponent implements OnInit {
    private maxRow = -1;

    @Input() DocDefTemplate: NJDocDefTemplate

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;


    @Input() isValid: boolean = true;
    @Input() isHideTitles: boolean = false;
    @Input() isEnabled: boolean = true;

    @Input() GridID: any
    @Input() isPopUpYesNo: string;
    @Input() isPopUpSelected: boolean = false;

    @Input() public hasEvent: boolean = false;

    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();

    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() doubleClick: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();

    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() gridAfterViewInit: EventEmitter<GridInternalNoCacheComponent> = new EventEmitter<GridInternalNoCacheComponent>();

    public height = 500;
    public rowHeight;
    public width = 100;

    private ExternalFilterModel: string = "";
    private ExternalFilterKey: string = "";

    private _columnDefs: any[];
    get columnDefs(): any[] {
        return this._columnDefs;
    }
    set columnDefs(value: any[]) {
        this._columnDefs = value;
    }
    private _rowData: any[];
    get rowData(): any[] {
        return this._rowData;
    }
    set rowData(value: any[]) {
        this._rowData = value;
    }
    _getRows: number[];
    get getRows(): number[] {
        return this._getRows;
    }
    set getRows(value: number[]) {
        this._getRows = value;
    }
    public gridOptions = {
        defaultColDef: {
            sortable: true,
            filter: true
        },
        //pagination
        pagination: false,
        paginationPageSize: 10,
        // Setting Last Row Index
        cacheBlockSize: 1000,
        rowDeselection: true
    }
    private gridIsSecondary: boolean = false;
    public components;
    public frameworkComponents;
    private cacheData: boolean;

    public gridApi;
    public gridColumnApi;
    public params;

    public rowBuffer;
    public defaultColDef;
    public rowModelType;
    public rowSelection;
    public maxBlocksInCache;
    public getRowNodeId;
    public cacheOverflowSize;
    public maxConcurrentDatasourceRequests;
    public infiniteInitialRowCount;
    public datasource;

    public isHidden: boolean = false;
    errorMessage: string;
    // declare a property object to hold row data
    public selectedRow = {};
    public selectedRowkeyTemplateId = -1;

    private _cellRendererParamsDefs: any[];
    get cellRendererParamsDefs(): any[] {
        return this._cellRendererParamsDefs;
    }
    set cellRendererParamsDefs(value: any[]) {
        this._cellRendererParamsDefs = value;
    }

    constructor(public data: DocDefPrimLibService) {
        this.defaultColDef = { resizable: true };
        //this.columnDefs = getColumnDefs();
        this.rowBuffer = 0;
        this.rowModelType = "infinite";
        // this.rowSelection = "multiple";
        this.cacheOverflowSize = 2;
        this.maxConcurrentDatasourceRequests = 1;
        this.infiniteInitialRowCount = 1000;
        this.maxBlocksInCache = 10;

        this.frameworkComponents = {
            CheckboxRendererComponent: CheckboxRendererComponent,
            ButtonRendererComponent: ButtonRendererComponent,
            DropdownRendererComponent: DropdownRendererComponent
        };

    }
    isvalid():string {
        if (!this.isValid)
            return "border border-danger";
        else
            return "";
    }
    
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        let _this = this;
        if (params.sortModel == undefined) {
            params.sortModel = [];
        }
        var dataSource = {
            rowCount: null,
            getRows: function (params) {
                _this.params = params;
                _this.onRequestRows(true);
                if (_this.ExternalFilterModel.length > 0) { // Apply external filter
                    let parsedFilterModel = JSON.parse(_this.ExternalFilterModel)
                    if (parsedFilterModel.filter == "") {
                        delete params.filterModel[_this.ExternalFilterKey]
                    } else {
                        params.filterModel[_this.ExternalFilterKey] = parsedFilterModel;
                    }
                }

                params.context = _this.DocDefTemplate;

                if (_this.lstDocData) {
                    //if (_this.gridIsSecondary) {
                        if (params.startRow == 0)
                            _this._getRows = [];
                        //get unique rows and the field to be sorted on (default to first field)
                        for (let i: number = 0; i < _this.lstDocData.length; i++) {
                            if (_this.getRows.map(function (e) { return e }).indexOf(_this.lstDocData[i].docDefDataRowID) === -1) {
                                _this.getRows.push(_this.lstDocData[i].docDefDataRowID)
                            }
                        }
                    //}
                }
                // read ponters into array
                let rowDataLocal: Array<number> = new Array<number>();
                for (let i: number = 0; i < _this.lstDocData.length; i++) {
                    if (rowDataLocal.map(function (e) { return e }).indexOf(_this.lstDocData[i].docDefDataRowID) === -1)
                        rowDataLocal.push(_this.lstDocData[i].docDefDataRowID);
                }
                var rowsThisPage = [];
                setTimeout(function () {
                    for (var rowIndex = 0; rowIndex < params.endRow - params.startRow; rowIndex++) {
                        var record = {};
                        let docDataRowID = rowDataLocal[rowIndex];
                        for (let template of _this.lstChildDocDefTemplate) {
                            let d: DOData = new DOData();
                            //let data: Array<NJDocData> = _this.lstDocData.filter((d: NJDocData) => {
                            let data: Array<NJDocData> = _this.lstDocData.filter((d: NJDocData) => {
                                return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID && template.docDefTemplateID)
                            })
                            if (data.length == 1)
                                record["T" + template.docDefTemplateID.toString()] = data[0].dataValue;
                            else {
                                record["T" + template.docDefTemplateID.toString()] = "";
                            }
                            record["id"] = docDataRowID == undefined ? null : docDataRowID.toString();
                        }
                        rowsThisPage.push(record);
                    }
                    params.successCallback(rowsThisPage, _this.getLastRowIndex(_this.getRows.length, params));
                    _this.onRequestRows(false);

                }, 500);
            }
        }
        params.api.setDatasource(dataSource);

    }


    getLastRowIndex(currentLastRow, params) {
        if (!params) return undefined;
        return currentLastRow < params.endRow ? currentLastRow : params.endRow + 1;
    }
    
    ngOnInit() {
        this.hide_grid();
        this.calc_data();
        //this.datasource = this.getDataSource(100);

        if (this.customParameters.TableHeight != null) {
            this.height = this.customParameters.TableHeight
        }

        if (this.customParameters['hasEvent'] != null) {
            this.hasEvent = true;
        }

        if (this.customParameters.rowHeight != null) {
            this.rowHeight = this.customParameters.rowHeight
        }
        this.setHiddenStatus();
    }

    hide_grid() {
        if (this.customParameters.HideGrid != null) {
            this.height = 0;
            this.width = 0;
        }

    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
            //        });
        }
        else this.isHidden = false;
    }

    // returns a formatted time string
    getTimeFormat(d: any, format: string) {
        var hours: number = d.getHours();
        var mm: string = d.getMinutes().toString();
        var ss: string = d.getSeconds().toString();
        var ms: string = d.getMilliseconds().toString();
        var xm: string = (hours > 12) ? "pm" : "am";
        if (hours > 12) hours -= 12;
        var hh: string = hh.toString();
        if (hh.length < 2) hh = "0" + hh;
        if (mm.length < 2) mm = "0" + mm;
        if (ss.length < 2) ss = "0" + ss;
        var formattedTime: string = "";
        switch (format) {
            case "hh:mm:ss xm":
                formattedTime = hh + ":" + mm + ":" + ss + " " + xm;
                break;
            default:
                formattedTime = hh + ":" + mm + ":" + ss + " " + xm;
                break;
        }
        return formattedTime;
    }

    calc_data() {
        this.getRows = [];
        //Is Grid1, Grid2, Grid3, Grid4 ... case insensitive.
        if (this.DocDefTemplate.tType.toUpperCase().startsWith("GRID") && this.DocDefTemplate.tType.toUpperCase() != "GRID")
            this.gridIsSecondary = true;
        if (this.customParameters.CacheData == null)
            this.cacheData = true
        else
            this.cacheData = this.customParameters.CacheData == "False" ? false : true;

        //get unique rows and the field to be sorted on (default to first field)
        for (let i: number = 0; i < this.lstDocData.length; i++) {
            if (this.getRows.map(function (e) { return e }).indexOf(this.lstDocData[i].docDefDataRowID) === -1) {
                this.getRows.push(this.lstDocData[i].docDefDataRowID)
            }
        }
        // cols
        this._columnDefs = [];
        let _this = this;
        for (let template of this.lstChildDocDefTemplate) {
            let col = {};

            col["headerClass"] = 'ag-grid-HeaderClass'; // must be defined in the project golbal styles
            col["headerName"] = template.tLabel;
            if (template.dictCustomParameters.width) {
                col["width"] = parseInt(template.dictCustomParameters.width);
            }
            // col["rowSelection"] = "multiple";
            col["field"] = "T" + template.docDefTemplateID.toString();
            if (template.tLabel == "Remove")
                col["sortable"] = false;
            else
                col["sortable"] = true;
            if (typeof template.dictCustomParameters.numberFmt !== 'undefined')
                col["filter"] = 'agNumberColumnFilter'
            else if (typeof template.dictCustomParameters.dateFmt !== 'undefined')
                col["filter"] = 'agDateColumnFilter'
            else
                col["filter"] = true;
            if (template.dictCustomParameters.numberFmt) {
                // not is not a number
                if (!isNaN(template.dictCustomParameters.numberFmt))
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        let ret = parseFloat(params.value).toFixed(+template.dictCustomParameters.numberFmt);
                        return ret;
                    }
            }
            if (template.dictCustomParameters.tooltip)
            {
                if (template.dictCustomParameters.tooltip == template.templateCode)
                    col["tooltipField"] = col["field"];
                else
                {
                    let _colToolTip: NJDocDefTemplate = this.lstChildDocDefTemplate.filter(x => x.templateCode == template.dictCustomParameters.tooltip)[0];
                    if (_colToolTip)
                        col["tooltipField"] = "T" + _colToolTip.docDefTemplateID.toString();
                }
            }
            if (template.dictCustomParameters.dollarFmt) {
                // not is not a number
                if (!isNaN(template.dictCustomParameters.dollarFmt))
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        let ret = "$" + parseFloat(params.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        return ret;
                    }
            }
            col["filterParams"] = {
                debounceMs: 2000
            }
            if (template.dictCustomParameters.dateFmt !== undefined) {
                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return "";
                    let d = new Date(params.value.replaceAll('-', '/'));
                    let month = '' + (d.getMonth() + 1);
                    let day = '' + d.getDate();
                    let year = d.getFullYear();

                    if (month.length < 2) month = '0' + month;
                    if (day.length < 2) day = '0' + day;
                    let ret = "";
                    switch (template.dictCustomParameters.dateFmt) {
                        case "yyyy-MM-dd":
                            ret = [year, month, day].join('-');
                            break;
                        case "MM-dd-yyyy":
                            ret = [month, day, year].join('-');
                            break;
                        case "yyyy/MM/dd":
                            ret = [year, month, day].join('/');
                            break;
                        case "MM/dd/yyyy":
                            ret = [month, day, year].join('/');
                            break;
                        case "24HR":
                            let intHours = d.getHours();
                            let minutes = '' + d.getMinutes();
                            let seconds = '' + d.getSeconds();
                            if (intHours === 0) intHours = 12;
                            let hours = '' + intHours;
                            if (hours.length < 2) hours = '0' + hours;
                            if (minutes.length < 2) minutes = '0' + minutes;
                            if (seconds.length < 2) seconds = '0' + seconds;
                            ret = "MM/dd/yyyy hh:mm:ss";
                            ret = ret.replace("MM", month);
                            ret = ret.replace("dd", day);
                            ret = ret.replace("yyyy", year.toString());
                            ret = ret.replace("hh", hours);
                            ret = ret.replace("mm", minutes);
                            ret = ret.replace("ss", seconds);
                            break;
                        case "AMPM":
                            {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (params.value.includes('PM')) {
                                    xm = 'PM';
                                } else if (params.value.includes('AM')) {
                                    xm = 'AM';
                                }
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                ret = "MM/dd/yyyy hh:mm xm";
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("xm", xm);
                                break;
                            }
                        case "AMPMwSeconds":
                            {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let seconds = '' + d.getSeconds();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (params.value.includes('PM')) {
                                    xm = 'PM';
                                } else if (params.value.includes('AM')) {
                                    xm = 'AM';
                                }
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                // Fix for Ticket #32456
                                if (seconds.length < 2) seconds = '0' + seconds;
                                ret = "MM/dd/yyyy hh:mm:ss xm";
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("ss", seconds);
                                ret = ret.replace("xm", xm);
                                break;
                            }
                        default:
                            if (template.dictCustomParameters.dateFmt.length > 10) {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let seconds = '' + d.getSeconds();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                if (seconds.length < 2) seconds = '0' + seconds;
                                ret = template.dictCustomParameters.dateFmt;
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("ss", seconds);
                                ret = ret.replace("xm", xm);
                            }
                            else {
                                ret = [month, day, year].join('-');
                            }
                            break;
                    }
                    if ((month === "1" || month === "01") && (day === "1" || day === "01") && year.toString() === "1900")
                        ret = "";
                    return ret;
                }
            }

            if (template.dictCustomParameters.ssnFmt) {
                col["valueFormatter"] = function (params) {
                    if (!params.value) return "";
                    let ssn = params.value.trim();
                    if (ssn.length != 9) return params.value;
                    let ret = "";
                    switch (template.dictCustomParameters.ssnFmt) {
                        case "MaskedAllButLast4":
                            ret = "XXX-XX-" + ssn.substring(5);
                            break;
                        case "Dashed":
                            ret = ssn.substring(0, 3) + "-" +
                                ssn.substring(3, 5) + "-" +
                                ssn.substring(5);
                            break;
                        default:
                            ret = params.value;
                    }
                    return ret;
                }
            }

            // Returns "Yes" if there is a value; "No" if not
            if (template.dictCustomParameters.yesNoFmt) {
                col["valueFormatter"] = function (params) {
                    if (params.value === null || params.value === undefined) return "";
                    return params.value.trim().length === 0 ? "No" : "Yes";
                }
            }

            if (template.dictCustomParameters.isPhone) {
                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return "";
                    var lenDiff = params.value.length;
                    var x = params.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    params.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                    //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
                    if (lenDiff - params.value.length > 0) {
                        params.value = new String(params.value);
                    }
                    return params.value;
                }
            }

            if (template.dictCustomParameters.dropdown !== undefined) {
                col["cellRenderer"] = "DropdownRendererComponent";
                //col["cellEditorFramework"] = "DropdownRendererComponent";
                //col["editable"] = true;

                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return 0;
                    else
                        return params.value;
                }
                // define cellRendererParams
                let cellParamscol = {};
                cellParamscol["dropdown"] = template.dictCustomParameters.dropdown.toLowerCase() == 'dropdown';
                cellParamscol["template"] = template;
                cellParamscol["origHeight"] = -1;  
                if (template.dictCustomParameters.DropdownHeight)
                    cellParamscol["DropdownHeight"] = template.dictCustomParameters.DropdownHeight;
                else
                    cellParamscol["DropdownHeight"] = 200;
                cellParamscol["lstDocDefTemplateLookup"] = this.lstDocDefTemplateLookup;
                col["cellRendererParams"] = cellParamscol;
                cellParamscol["onClick"] = this.onDropdownClick.bind(_this);
                //col["cellEditorParams"] = cellParamscol;
            }
            if (template.tType == "Button") {
                if (template.dictCustomParameters.Link) {
                    col["cellRenderer"] = "ButtonRendererComponent";
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        else
                            return params.value;
                    }

                    // define cellRendererParams
                    this._cellRendererParamsDefs = [];
                    let cellParamscol = {};

                    cellParamscol["onClick"] = this.onLinkButtonClick.bind(_this);
                    cellParamscol["template"] = template;
                    cellParamscol["isLink"] = true; 
                    cellParamscol["isDisabled"] = !this.isEnabled; 
                    if (template.dictCustomParameters.ButonIcon) {
                        cellParamscol["ButonIcon"] = true;
                    }
                    col["cellRendererParams"] = cellParamscol;
                }
                else if (template.dictCustomParameters.remove) {
                    col["cellRenderer"] = "ButtonRendererComponent";
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        else
                            return params.value;
                    }

                    // define cellRendererParams
                    this._cellRendererParamsDefs = [];
                    let cellParamscol = {};
                    cellParamscol["onClick"] = this.onDeleteButtonClick.bind(_this);
                    cellParamscol["template"] = template;
                    cellParamscol["label"] = template.tLabel;
                    cellParamscol["isLink"] = false; 
                    cellParamscol["isDisabled"] = !this.isEnabled; 
                    col["cellRendererParams"] = cellParamscol;
                }

                else {
                    col["cellRenderer"] = function (params) {
                        if (params.value !== undefined) {
                            return '<a href="# " onclick="return false;">' + params.value + '</a>'
                        } else {
                            return '<img src="images/loading.gif">';
                        }
                    }
                }
            }

            if (template.tType == "CheckBox") {
                col["editable"] = true;
                col["cellRenderer"] = "CheckboxRendererComponent";
                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return false;
                    else
                        return params.value;
                }
                this._cellRendererParamsDefs = [];
                let cellParamscol = {};
                cellParamscol["template"] = template;
                cellParamscol["lstDocDefTemplateLookup"] = this.lstDocDefTemplateLookup;
                cellParamscol["onClick"] = this.onCheckBoxClick.bind(this);
                cellParamscol["isDisabled"] = !this.isEnabled; 
                col["cellRendererParams"] = cellParamscol;
            }
            if (!col["cellRenderer"])
                if (this._columnDefs.length == 0)
                    col["cellRenderer"] = 'loadingRenderer'
            if (template.dictCustomParameters.hideCol !== undefined) {
                if (template.dictCustomParameters.hideCol == "true")
                    col["hide"] = true;
            }
            if (template.dictCustomParameters.autoHeight !== undefined) {
                if (template.dictCustomParameters.autoHeight.toLowerCase() == 'true')
                    col["autoHeight"] = true;
            }
            if (template.dictCustomParameters.wrapText !== undefined) {
                if (template.dictCustomParameters.wrapText.toLowerCase() == 'true')
                    col["wrapText"] = true;
            }
            this._columnDefs.push(col);

        }
        this.getRowNodeId = function (item) {
            return item.id;
        };
        // data
        this.rowSelection = "multiple";
        this._rowData = [];
        this.components = {
            loadingRenderer: function (params) {
                if (params.value !== undefined) {
                    return params.value;
                    //<img src="https://raw.githubusercontent.com/ag-grid/ag-grid/master/grid-packages/ag-grid-docs/src/images/loading.gif">
                } else {//<span><i class="fas fa-cog fa-spin"></i></span>
                    return '<img src="images/loading.gif">';
                }
            }
        };
    }
    // Purpose: To return the selected data in the grid
    getAllSelectedRowData() {
        let selectedNodes = this.gridApi.getSelectedNodes();
        let selectedData = selectedNodes.map(node => node.data);
        let retData: Array<string> = new Array<string>();
        for (var i = 0; i < selectedData.length; i++) {
            retData.push(selectedData[i]);
        }
        return retData;
    }
    // Purpose: If custom parameter KeyColumnField is set:
    //              Return the KeyColumnField column for the selected row(s)
    //              Else return the selected data in the grid
    getSelectedRowData() {
        let templateCodeKey = this.customParameters.KeyColumnField
        let lstTemplate = this.lstChildDocDefTemplate.filter(function (item) {
            return item.templateCode == templateCodeKey;
        });
        if (lstTemplate.length == 1) {
            var keyColumn;
            this.selectedRowkeyTemplateId = lstTemplate[0].docDefTemplateID;
            keyColumn = "T" + lstTemplate[0].docDefTemplateID;
        }
        else {
            templateCodeKey = "";
        }
        let selectedNodes = this.gridApi.getSelectedNodes();
        let selectedData = selectedNodes.map(node => node.data);
        let retData: Array<string> = new Array<string>();
        if (templateCodeKey == "")
            for (var i = 0; i < selectedData.length; i++) {
                retData.push(selectedData[i]);
            }
        else
            for (var i = 0; i < selectedData.length; i++) {
                retData.push(selectedData[i][keyColumn]);
            }
        // alert(`Selected Nodes:\n${JSON.stringify(selectedData)}`);
        return retData;
    }

    deselectAllRows() {
        this.gridApi.deselectAll();
    }

    // Purpose: get column data by coloumn template code
    // this data could be used for populating a drop down             
    //              
    getColumnDataByColumnTemplateCode(templateCodeKey: string) {
        let lstTemplate = this.lstChildDocDefTemplate.filter(function (item) {
            return item.templateCode == templateCodeKey;
        });

        var keyColumn;
        if (lstTemplate.length == 1) {
            this.selectedRowkeyTemplateId = lstTemplate[0].docDefTemplateID;
            keyColumn = "T" + lstTemplate[0].docDefTemplateID;
        }

        let rowData: Array<any> = [];
        this.gridApi.forEachNode(function (node) {
            rowData.push(node.data[keyColumn]);
        });
        return rowData;
    }

    onCheckBoxClick(params) {
        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = params;
        DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
        DOMessage.njDocDefTemplate = params.template;
        DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
        DOMessage.customParameters = params.template.customParameters;
        this.clickBut.emit(DOMessage);
    }
    
    onDeleteButtonClick(params) {

        let nodeIndex: number = params.data.id;
        let selectedNode: RowNode = this.gridApi.getRowNode(nodeIndex);
        let lstDocData: Array <NJDocData>= new Array<NJDocData>();
        let docDataHdrId: number=-1;
        let docDefTemplateID: number = -1;
        let docDefDataRowID: number = nodeIndex;
        let docDefDataRowParID: number = 0;

        let k: keyof typeof selectedNode.data;

        let DocData: NJDocData;
        for (k in selectedNode.data) {
            const dataValue = selectedNode.data[k];
            let strKey: string = k;

            if (strKey.substring(0, 1) == "T") {

                docDefTemplateID = + strKey.substring(1);

                DocData = new NJDocData();
                DocData.dataValue = dataValue;
                DocData.docDefTemplateID = docDefTemplateID;
                DocData.docDefDataRowParID = docDefDataRowParID;
                DocData.docDefDataRowID = docDefDataRowID;
                DocData.docDataHdrId = docDataHdrId;
                lstDocData.push(DocData);
            }
        }

        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = params;
        DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
        DOMessage.njDocDefTemplate = params.template;
        DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
        DOMessage.lstDocData = lstDocData;
        DOMessage.customParameters = params.template.customParameters;
        this.clickBut.emit(DOMessage);
    }
    onLinkButtonClick(params) {
        if (this.isEnabled) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = params;
            DOMessage.njDocData.dataValue = params.value;
            DOMessage.njDocDefTemplate = params.template;
            DOMessage.lstChildDocDefTemplate[0] = params.template;
            DOMessage.customParameters = params.template.customParameters;
            this.clickBut.emit(DOMessage);
        }

    }
    onDropdownClick(params) {
        //save selection
        if (Number.isInteger(params.event)) {
            //params.node.setRowHeight(params.origHeight);
            let DocDataSave: DocdefDataVM = new DocdefDataVM();
            let lstDocdata: Array<NJDocData> = new Array<NJDocData>();
            let itemDocdata: NJDocData = new NJDocData();
            DocDataSave.docdata = lstDocdata;
            itemDocdata.dataValue = params.value;
            itemDocdata.docDefTemplateID = params.template.docDefTemplateID;
            itemDocdata.docDefDataRowID = params.node.id;
            lstDocdata.push(itemDocdata);

            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = params;
            DOMessage.njDocData.dataValue = params.node.data["T" + params.template.docDefTemplateID];
            DOMessage.njDocDefTemplate = params.template;
            DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
            DOMessage.customParameters = params.template.customParameters;
            this.clickBut.emit(DOMessage);


        } else
         //save selection
        {
            if (params.event == "resetRowHeights") {
                params.node.setRowHeight(params.DropdownHeight);
            }
            if (params.event == "blur")
                params.node.setRowHeight(params.origHeight);
        }
        this.gridApi.onRowHeightChanged();
    }
    getDataSource(count) {
        function GridDatasource(rowCount) {
            this.rowCount = rowCount;
        }
        let _this = this;
        GridDatasource.prototype.getRows = function (params) {
            var rowsThisPage = [];
            for (var rowIndex = params.startRow; rowIndex < params.endRow; rowIndex++) {
                var record = {};
                let docDataRowID = _this.getRows[rowIndex];
                for (let template of _this.lstChildDocDefTemplate) {
                    let d: DOData = new DOData();
                    let data: Array<NJDocData> = _this.lstDocData.filter((d: NJDocData) => {
                        return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID && template.docDefTemplateID)
                    })
                    if (data.length == 1)
                        record["T" + template.docDefTemplateID.toString()] = data[0].dataValue;
                    else {
                        record["T" + template.docDefTemplateID.toString()] = "";
                    }
                    record["id"] = docDataRowID;
                    //this._rowData.push(record);
                }
                rowsThisPage.push(record);
            }
            params.successCallback(rowsThisPage);
        };
        return new GridDatasource(count);
    }
    onCellDoubleClicked(params) {
        if (this.isEnabled) {
            let DOMessage: DOData = new DOData();
            let DocData: NJDocData = new NJDocData;

            DOMessage.njDocData = params.data;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.customParameters = this.customParameters;
            this.doubleClick.emit(DOMessage);
        }
    }

    cellColClicked: any;
    onCellClicked(event: Event) {
        let _cellClicked:any = event;
        this.cellColClicked = _cellClicked.colDef.field;
        //Warning: Any thing you put in here will be run twice during a double-click
    }
    onCheckBoxClicked(event: Event) {
    }
    onRowClicked(params) {
        this.selectedRow = params.data;

        if (this.customParameters.KeyColumnField !== undefined)
        {
            let templateCodeKey = this.customParameters.KeyColumnField
            let lstTemplate = this.lstChildDocDefTemplate.filter(function (item) {
                return item.templateCode == templateCodeKey;
            });
            if (lstTemplate.length == 1) {
                var keyColumn;
                this.selectedRowkeyTemplateId = lstTemplate[0].docDefTemplateID;
                keyColumn = "T" + lstTemplate[0].docDefTemplateID;

                let DOMessage: DOData = new DOData();
                let DocData: NJDocData = new NJDocData;

                var dataValue;
                dataValue = params.data[keyColumn];

                DocData.dataValue = dataValue;
                DOMessage.njDocData = DocData;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                DOMessage.customParameters = this.customParameters;
                this.clickBut.emit(DOMessage);
            }
        }
        else if (this.hasEvent)
        {
            this.selectedRow['cellClicked'] = this.cellColClicked;
            let DOMessage: DOData = new DOData();
            let DocData: NJDocData = new NJDocData;

            var dataValue;
            dataValue = this.selectedRow;

            DocData.dataValue = dataValue;
            DOMessage.njDocData = DocData;
            DOMessage.lstDocData = this.lstDocData;
            DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.customParameters = this.customParameters;
            this.clickBut.emit(DOMessage);
        }
    }
    callGridRefresh() {
        //this.gridApi.redrawRows();
        //this.gridApi.setDatasource()
        //this.gridApi.refreshInfiniteCache();
        if (this.gridApi !== null && this.gridApi !== undefined)
            this.gridApi.purgeInfiniteCache();
    }
    SetFilterModel(templateCode: string, value: string, customFilter: string = "") {
        if (templateCode == "") {
            this.gridApi.setFilterModel(null);
            this.gridApi.setSortModel(null);
            this.ExternalFilterModel = "";
             
            for (let template of this.lstChildDocDefTemplate) {
                if (this.params)
                    if (this.params.filterModel["T" + template.docDefTemplateID.toString()]) {
                       delete this.params.filterModel["T" + template.docDefTemplateID.toString()];
                    }
            }

        } else {
            this.ExternalFilterModel = "";
            for (let template of this.lstChildDocDefTemplate) {
                if (template.templateCode == templateCode) {
                    this.ExternalFilterModel =
                        customFilter === "" ?
                            '{"filterType":"text","type":"contains","filter":"' + value + '"}' :
                            customFilter;
                    this.ExternalFilterKey = "T" + template.docDefTemplateID.toString();
                }
            }
        }
    }

    onViewportChanged(event: any) {
        //if (event.lastRow>= 0) {
        //    this.FirstDisplayedRow = event.firstRow;
        //    this.LastDisplayedRow = event.lastRow
        //}
    }
    //Call from Wait
    onRequestRows(message: boolean) {
        this.requestRows.emit(message);
    }

    FilterColumn(columntoFilter:string, selectedValue:string) {
        var FilterComponent = this.gridApi.getFilterInstance(columntoFilter);
        FilterComponent.selectNothing(); //Cleared all options
        FilterComponent.selectValue(selectedValue)  //added the option i wanted
        FilterComponent.onFilterChanged();  
    }

    setFilterModel(Filter:any) {
        this.gridApi.setFilterModel(Filter);
    }

    ngAfterViewInit() {
        this.gridAfterViewInit.emit(this);
    }


}
